import React, { Component } from "react";
import { AgGridReact } from "ag-grid-react";
import { AllCommunityModule, ModuleRegistry, themeQuartz } from 'ag-grid-community';
import "ag-grid-enterprise";
import SwalServices from "../../../services/swalServices/SwalServices";
import { getAuthProps } from "../../../utils/AuthenticationLibrary";
import AccountTransactionServices from "../../../services/axiosServices/apiServices/AccountTransactionServices";
import ButtonGrp from "../../../components/UIComponent/Buttons/ButtonGrp";
import { AddCashAdvancePopUp, colDefs, rowData, table2ColDefs, table2Data } from "./AddCashAdvanceTable";
import { isValidForm } from "../../../utils/validation/CommonValidator";
import { CommonValidationMessages } from "../../../utils/Messages";
import moment from "moment";
import { decryptAES } from "../../../utils/Encryption";
import { Navigate } from "react-router-dom";
import { permission } from "../../../utils/enums/ValidationMessage";

class AddCashAdvance extends Component {
    constructor(props) {
        super(props);
        this.accountTransactionServices = new AccountTransactionServices();
        this.SwalServices = new SwalServices();
        this.state = {
            permissions: {
                isAddEdit: false,
                isDelete: false,
                isView: false,
            },
            isModalOpen: false,
            isSaving: false,
            isTable2Expanded: false,
            urlId: 0,
            prop: {},
            caption: "",
            colName: "",
            paginationPageSize: 50,
            rowHeight: 40,
            receiptDetails: {
                idCashOrAdvance: 0,
                receiptNo: "",
                date: "",
                accSubHead: [],
                selectEmployee: [],
                paymentMode: [],
                refNo: "",
                amount: "",
                loanNo: "",
                depositIn: [],
                remarks: "",
                employeeList: [],
                idEmployee: 0,
                employeeName: "",
                mainEmployeeList: [],
                aCCSubHeadList: [],
                mainACCSubHeadList: [],
                filterACCSubHeadList: [],
                idGeneralProduct: 0,
                productName: "",
                bankList: [],
                mainBankList: [],
                idBank: 0,
                bankName: "",
                paymentModeList: [],
                mainPaymentModeList: [],
                idPaymentMode: 0,
                paymentMode: "",
                idFinancialYear: 0,
                e_Date: "",
                updateStatus: 0,
            },
            rowData: [],
            colDefs: [],
            idCompany: 0,
            idUser: 0,
            idCashOrAdvance: 0,
            validState: {
                isValid: true,
                error: {},
            },
            validationRules: {
                date: [
                    {
                        type: "require",
                        message: CommonValidationMessages.FieldRequired.replace(
                            "{0}",
                            "date"
                        ),
                    },
                ],
                // idGeneralProduct: [
                //     {
                //         type: "require",
                //         message: CommonValidationMessages.FieldRequired.replace(
                //             "{0}",
                //             "account sub head"
                //         ),
                //     },
                // ],
                idEmployee: [
                    {
                        type: "require",
                        message: CommonValidationMessages.FieldRequired.replace(
                            "{0}",
                            "employee"
                        ),
                    },
                ],
                idPaymentMode: [
                    {
                        type: "require",
                        message: CommonValidationMessages.FieldRequired.replace(
                            "{0}",
                            "payment mode"
                        ),
                    },
                ],
                refNo: [
                    {
                        type: "require",
                        message: CommonValidationMessages.FieldRequired.replace(
                            "{0}",
                            "reference no"
                        ),
                    },
                ],
                amount: [
                    {
                        type: "require",
                        message: CommonValidationMessages.FieldRequired.replace(
                            "{0}",
                            "amount"
                        ),
                    },
                ],
                loanNo: [
                    {
                        type: "require",
                        message: CommonValidationMessages.FieldRequired.replace(
                            "{0}",
                            "loan no"
                        ),
                    },
                ],
                idBank: [
                    {
                        type: "require",
                        message: CommonValidationMessages.FieldRequired.replace(
                            "{0}",
                            "deposit in"
                        ),
                    },
                ],
            }
        };
    }

    toggleExpandCollapseTable = (tableNumber) => {
        this.setState((prevState) => {
            if (tableNumber === 2) {
                return { isTable2Expanded: !prevState.isTable2Expanded };
            } else if (tableNumber === 3) {
                return { isTable3Expanded: !prevState.isTable3Expanded };
            } else {
                return {};
            }
        });
    };

    handleCellClick = (event) => {
        //if (event.colDef.field === "piQty") {
        //debugger
        this.procSelectAllRecord2GridviewSP(event.data[this.state.colName], "Add Cash/Advance");
        //}
    };

    componentDidMount = () => {
        let params = new URLSearchParams(window.location.search);
        let id = params.get("id")
        if (id) {
            let urlId = decryptAES(id)
            if (urlId) {
                if (urlId != null) {
                    this.setState({ urlId: urlId });
                }
            }
        }


        let prop = getAuthProps()
        if (prop.idCompany && prop.idCompany > 0) {
            this.setState({ idCompany: prop.idCompany, idUser: prop.idUser }, () => {
                this.procSelectAllRecordsSP();
                this.usp_Master_GeneralProductSelect();
            }, () => {
                if (this.gridApi) {
                    this.gridApi.hideOverlay(); // Hide AG Grid's loading overlay
                }
            });
        } else {
            // window.location.href = "/Login";
        }
    }

    onGridReady = (params) => {
        this.gridApi = params.api;
        this.gridColumnApi = params.columnApi;
        this.gridApi.showLoadingOverlay(); // Show loading overlay initially
        setTimeout(() => {
            this.removeDefaultBorders();
        }, 0);
        // this.gridApi.addEventListener("bodyScroll", this.onGridScroll);

    };
    removeDefaultBorders = () => {
        // Select pinned columns and headers
        const pinnedHeader = document.querySelector(".ag-pinned-left-header");

        // Remove border from header
        if (pinnedHeader) {
            pinnedHeader.style.borderRight = "none";
        }

        // Function to remove borders from all pinned cells
        const removeCellBorders = () => {
            const pinnedCells = document.querySelectorAll(".ag-cell-last-left-pinned");
            pinnedCells.forEach((cell) => {
                cell.style.borderRight = "none";
            });
        };

        // Initial removal of cell borders
        removeCellBorders();

        // 🔹 MutationObserver: Ensure AG Grid does not reapply the border
        const observer = new MutationObserver(() => {
            if (pinnedHeader) pinnedHeader.style.borderRight = "none";
            removeCellBorders(); // Continuously remove borders from new cells
        });

        observer.observe(document.body, { childList: true, subtree: true });
    };
    // onGridScroll = (event) => {
    //     const pinnedHeader = document.querySelector(".ag-pinned-left-header");
    //     const pinnedCells = document.querySelectorAll(".ag-cell-last-left-pinned");
    //     const pinnedRow = document.querySelector(".ag-pinned-left-cols-container");

    //     if (event.left > 0) {
    //         // Show border when scrolling right
    //         if (pinnedHeader) pinnedHeader.style.borderRight = "1px solid lightgray";
    //         if (pinnedRow) pinnedRow.style.borderRight = "1px solid lightgray";
    //     } else {
    //         // Hide border when at the left
    //         if (pinnedHeader) pinnedHeader.style.borderRight = "none";
    //         if (pinnedRow) pinnedRow.style.borderRight = "none";
    //     }
    // };

    procSelectAllRecordsSP = () => {
        let request = {
            formname: "Add Cash/Advance",
            idCompany: this.state.idCompany,
            allowToRateVisible: 1,
            idUser: this.state.idUser,
            //idFinancialYear : null,
            //idPlant : 0,
        };
        this.accountTransactionServices.procSelectAllRecordsSP(request).then((response) => {
            if (response.statusCode == 200 && response.responseItem !== null) {
                let permissions = response.responseItem.responseContent[0][0];
                if (permissions.view) {
                    let data = response.responseItem.responseContent[1];
                    if (data.length > 0) {
                        // const key = Object.keys(data[0]).map((key) => {
                        //     console.log(key); // Log the key
                        // })
                        const dynamicColDefs = Object.keys(data[0]).map((key) => ({
                            field: key.includes(".") ? key.replace(/\./g, "_") : key,
                            headerName: key.replace(/([A-Z])/g, ' $1').charAt(0).toUpperCase() + key.replace(/([A-Z])/g, ' $1').slice(1),
                            filter: true,
                            floatingFilter: true,
                            flex: 1,
                            minWidth: this.getColumnWidth(key),
                            pinned: ["sR.No", "receiptNo", "date"].includes(key) ? true : false,
                            width: this.getPinnedWidth(key),
                            hide: key === "idCashOrAdvance" ? true : false,
                            valueGetter: (params) => params.data[key],
                            // valueFormatter: key.toLowerCase().includes("date") ? (params) => {
                            //     if (!params.value) return "";
                            //     const date = new Date(params.value);
                            //     return `${date.getDate().toString().padStart(2, "0")}-${(date.getMonth() + 1).toString().padStart(2, "0")}-${date.getFullYear()}`;
                            // } : undefined,
                        }));
                        var colName = dynamicColDefs[0].field;
                        let id = data ? data[0][colName] : 0;
                        data.map((x) => {
                            x.date = moment(x.date).format("DD-MM-YYYY");
                        });
                        this.setState({
                            rowData: data,
                            colDefs: dynamicColDefs,
                            caption: "Add Cash/Advance",
                            colName: colName
                        }, () => {
                            this.setPermissions(permissions);
                            this.procSelectAllRecord2GridviewSP(id, "Add Cash/Advance");
                            this.getTransaction_AddCashOrAdvanceCount();
                            if (this.state.urlId) {
                                this.openPopUpFromURLId(this.state.urlId)
                            }

                        });
                    } else {
                        this.setPermissions(permissions);
                        this.getTransaction_AddCashOrAdvanceCount();
                        if (this.gridApi) {
                            this.gridApi.showNoRowsOverlay();
                        }
                    }
                } else {
                    window.location.href = "/authentication/UnAuthorized";
                }
            } else {
                this.getTransaction_AddCashOrAdvanceCount();

            }
        });
    }

    setPermissions = (permissions) => {
        let data = this.state.permissions;
        data.isAddEdit = permissions.addEdit;
        data.isDelete = permissions.delete;
        data.isView = permissions.view;
        this.setState({ permissions: data });
    }


    openPopUpFromURLId = (id) => {
        this.setState({ idCashOrAdvance: id }, () => {
            this.getAddCashOrAdvanceSelectbyId();
        });
    };

    getColumnWidth = (key) => {
        const columnWidths = {
            "employeeName": window.innerWidth * 0.18,
            "bankName": window.innerWidth * 0.23,
            "amount": window.innerWidth * 0.05,
        };
        return columnWidths[key];
    };
    getPinnedWidth = (key) => {
        const pinnedWidths = {
            "sR.No": window.innerWidth * 0.05,
            "receiptNo": window.innerWidth * 0.05,
            "date": window.innerWidth * 0.07,
            "subHead": window.innerWidth * 0.13,
        }
        return pinnedWidths[key];
    }

    procSelectAllRecord2GridviewSP = (id, formname) => {
        let request = {
            id: id,
            formname: formname,
            allowToRateVisible: 1,
            //idCompany: this.state.prop.idCompany
        }
        if (id > 0) {
            this.accountTransactionServices.procSelectAllRecord2GridviewSP(request).then((response) => {
                if (response.statusCode == 200 && response.responseItem !== null) {
                    const dynamicData = response.responseItem.responseContent;
                    if (dynamicData.length > 0) {
                        const dynamicColDefs = Object.keys(dynamicData[0]).map((key) => ({
                            field: key,
                            headerName: key.replace(/([A-Z])/g, ' $1').charAt(0).toUpperCase() + key.replace(/([A-Z])/g, ' $1').slice(1),
                            flex: 1
                        }));
                        this.setState({
                            table2Data: dynamicData,
                            table2ColDefs: dynamicColDefs,
                            isTable2Expanded: true
                        });
                    } else {
                        this.setState({
                            table2Data: [],
                            table2ColDefs: []
                        });
                    }
                }
            });
        }
    };

    getTransaction_AddCashOrAdvanceCount = () => {
        let request = {
            idCompany: this.state.idCompany,
            idFinancialYear: 0
        };
        this.accountTransactionServices.getTransaction_AddCashOrAdvanceCount(request).then((response) => {
            if (response.statusCode == 200 && response.responseItem !== null) {
                let list = this.state.rowData;
                let maxIdPaymentMake = list.length > 0
                    ? Math.max(...list.map(item => item.idCashOrAdvance))
                    : 0;
                let receiptNo = String(maxIdPaymentMake + 1).padStart(3, '0');
                let data = this.state.receiptDetails;
                data.receiptNo = receiptNo;
                this.setState({
                    receiptDetails: data
                });
            }
        });
    }

    usp_Master_GeneralProductSelect = () => {
        this.accountTransactionServices.usp_Master_GeneralProductSelect(this.state.idCompany).then((response) => {
            if (response.statusCode == 200 && response.responseItem !== null && response.responseItem.responseContent.length > 0) {
                let data = response.responseItem.responseContent.map((x) => ({
                    id: x.idGeneralProduct,
                    name: x.productName,
                }));
                let receiptDetail = this.state.receiptDetails;
                receiptDetail.aCCSubHeadList = data;
                receiptDetail.mainACCSubHeadList = data;
                receiptDetail.filterACCSubHeadList = data;
                receiptDetail.mainACCSubHeadList = data;
                this.setState({ receiptDetails: receiptDetail }, () => {
                    this.usp_Master_EmployeeSelect();
                    if (this.gridApi) {
                        this.gridApi.hideOverlay(); // Hide loading overlay when data is present
                    }
                });
            } else {
                this.usp_Master_EmployeeSelect();
            }
        })
    };


    usp_Master_EmployeeSelect = () => {
        this.accountTransactionServices.usp_Master_EmployeeSelect_WithNewChanges(this.state.idCompany).then((response) => {
            // debugger
            if (response.statusCode == 200 && response.responseItem !== null) {
                let data = response.responseItem.responseContent;
                data = data.map((x) => ({
                    id: x.idEmployee,
                    name: x.employeeName,
                    idGeneralProduct: x.idGeneralProduct
                }));
                let receiptDetail = this.state.receiptDetails;
                receiptDetail.employeeList = data;
                receiptDetail.mainEmployeeList = data;
                this.setState({
                    receiptDetails: receiptDetail
                }, () => {
                    this.usp_Master_BankSelect();
                });
            } else {
                this.usp_Master_BankSelect();
            }
        });
    }

    usp_Master_BankSelect = () => {
        this.accountTransactionServices.usp_Master_BankSelect(this.state.idCompany).then((response) => {
            if (response.statusCode == 200 && response.responseItem !== null) {
                let dynamicData = response.responseItem.responseContent;
                dynamicData = dynamicData.map((x) => ({
                    id: x.idBank,
                    name: x.bankName,
                }));
                let receiptDetail = this.state.receiptDetails;
                receiptDetail.bankList = dynamicData;
                receiptDetail.mainBankList = dynamicData;
                this.setState({
                    receiptDetails: receiptDetail
                }, () => {
                    this.usp_Master_PaymentModeSelect();
                });
            } else {
                this.usp_Master_PaymentModeSelect();
            }
        });
    }

    usp_Master_PaymentModeSelect = () => {
        this.accountTransactionServices.usp_Master_PaymentModeSelect(this.state.idCompany).then((response) => {
            if (response.statusCode == 200 && response.responseItem !== null) {
                let dynamicData = response.responseItem.responseContent;
                if (dynamicData.length > 0) {
                    dynamicData = dynamicData.map((x) => ({
                        id: x.idPaymentMode,
                        name: x.paymentMode,
                    }));
                    let receiptDetail = this.state.receiptDetails;
                    receiptDetail.paymentModeList = dynamicData;
                    receiptDetail.mainPaymentModeList = dynamicData;
                    this.setState({ receiptDetails: receiptDetail }, () => {
                        // this.usp_Master_BankSelect();
                    });

                } else {
                    // this.usp_Master_BankSelect();
                }
            }
        });
    }

    getAddCashOrAdvanceSelectbyId = () => {
        this.accountTransactionServices.getAddCashOrAdvanceSelectbyId(this.state.idCashOrAdvance).then((response) => {
            if (response.statusCode == 200 && response.responseItem !== null) {
                let dynamicData = response.responseItem.responseContent[0];
                if (dynamicData !== null) {
                    // dynamicData = dynamicData.map((x) => ({
                    //     id: x.idPaymentMode,
                    //     name: x.paymentMode,
                    // }));

                    let receiptDetail = this.state.receiptDetails; //{
                    receiptDetail.idCashOrAdvance = dynamicData.idCashOrAdvance;
                    receiptDetail.receiptNo = dynamicData.receiptNo;
                    receiptDetail.date = moment(dynamicData.date).format('YYYY-MM-DD');
                    receiptDetail.refNo = dynamicData.referenceNo;
                    receiptDetail.amount = dynamicData.amount;
                    receiptDetail.loanNo = dynamicData.loanNo;
                    receiptDetail.remarks = dynamicData.remarks;
                    receiptDetail.idEmployee = dynamicData.idEmployee;
                    receiptDetail.employeeName = dynamicData.idEmployee > 0 ? receiptDetail.employeeList?.find(item => item.id === dynamicData.idEmployee)?.name : "";
                    receiptDetail.idGeneralProduct = dynamicData.idAccountHead;
                    receiptDetail.productName = dynamicData.idAccountHead > 0 ? receiptDetail.aCCSubHeadList?.find(item => item.id === dynamicData.idAccountHead)?.name : "";
                    receiptDetail.idBank = dynamicData.idBank;
                    receiptDetail.bankName = dynamicData.idBank > 0 ? receiptDetail.bankList?.find(item => item.id === dynamicData.idBank)?.name : "";
                    receiptDetail.idPaymentMode = dynamicData.paymentMode;
                    receiptDetail.paymentMode = dynamicData.paymentMode > 0 ? receiptDetail.paymentModeList?.find(item => item.id === dynamicData.paymentMode)?.name : "";
                    receiptDetail.idFinancialYear = 0;
                    receiptDetail.e_Date = dynamicData.e_Date;
                    receiptDetail.updateStatus = 1;
                    this.setState({
                        receiptDetails: receiptDetail
                    }, () => {
                        this.setState({ isModalOpen: true });
                    });
                } else {
                    //this.usp_Master_BankSelect();
                }
            }
        });
    }

    onRowDoubleClicked = (event) => {
        if (!this.state.permissions.isAddEdit) {
            this.SwalServices.Error(permission.edit);
            return;
        }
        this.resetDetailsFields();
        let validState = this.state.validState;
        validState.isValid = true;
        validState.error = {};
        this.setState(
            {
                validState: validState,
                idCashOrAdvance: event.data.idCashOrAdvance
            },
            () => {
                this.getAddCashOrAdvanceSelectbyId();
            }
        );
    };

    setOpenModel = () => {
        if (this.state.urlId) {
            this.setState({ route: '/ledger-report' });
        }
        this.resetDetailsFields();
        this.setState({ isModalOpen: !this.state.isModalOpen }, () => {
            this.getTransaction_AddCashOrAdvanceCount();
        });
    };
    openPopUpForAddingItem = () => {
        if (!this.state.permissions.isAddEdit) {
            this.SwalServices.Error(permission.add);
            return;
        }
        this.setState({ isModalOpen: true })
    };

    handleChange = (event, name) => {
        let details = this.state.receiptDetails;
        let value = event.target.value;
        details[name] = value;
        this.setState({ receiptDetails: details });
    }
    handleSelectChange = (event, name) => {
        // let select = event.target.value;
        // let details = this.state.receiptDetails;
        // details[name] = select;
        // this.setState({ receiptDetails: details });
        if (name === "aCCSubHeadList") {
            // debugger
            let arr = this.state.receiptDetails.filterACCSubHeadList;
            let value = "";
            value = event.target.value;
            let found;
            if (value === "" || value === null) {
                found = arr;
            } else {
                found = arr.filter((element) =>
                    element.name.toLowerCase().includes(value.toLowerCase())
                );
            }
            let data = this.state.receiptDetails;
            data.productName = value;
            data.aCCSubHeadList = found;
            this.setState({ receiptDetails: data });
        } else if (name === "employeeList") {
            // debugger
            let arr = this.state.receiptDetails.mainEmployeeList;
            let value = "";
            value = event.target.value;
            let found;
            if (value === "" || value === null) {
                found = arr;
            } else {
                found = arr.filter((element) =>
                    element.name.toLowerCase().includes(value.toLowerCase())
                );
            }
            let data = this.state.receiptDetails;
            data.employeeName = value;
            data.employeeList = found;
            this.setState({ receiptDetails: data });
        } else if (name === 'PaymentMode') {
            //debugger
            let arr = this.state.receiptDetails.mainPaymentModeList;
            let value = "";
            value = event.target.value;
            let found;
            if (value === "" || value === null) {
                found = arr;
            } else {
                found = arr.filter((element) =>
                    element.name.toLowerCase().includes(value.toLowerCase())
                );
            }
            let data = this.state.receiptDetails;
            data.paymentMode = value;
            data.paymentModeList = found;
            this.setState({ receiptDetails: data });
        } else if (name === 'depositIn') {
            //debugger
            let arr = this.state.receiptDetails.mainBankList;
            let value = "";
            value = event.target.value;
            let found;
            if (value === "" || value === null) {
                found = arr;
            } else {
                found = arr.filter((element) =>
                    element.name.toLowerCase().includes(value.toLowerCase())
                );
            }
            let data = this.state.receiptDetails;
            data.bankName = value;
            data.bankList = found;
            this.setState({ receiptDetails: data });
        }
    }

    setFilterParameters = (id, name, drpIdentity) => {
        //debugger
        let data = this.state.receiptDetails;
        if (drpIdentity === 'aCCSubHeadList') {
            data.idGeneralProduct = id;
            data.productName = name;
        }
        if (drpIdentity === 'employeeList') {
            data.idEmployee = id;
            data.employeeName = name;
            data.idGeneralProduct = data.mainEmployeeList?.find(item => item.id === id)?.idGeneralProduct > 0 ? data.mainEmployeeList?.find(item => item.id === id)?.idGeneralProduct : 0;
            data.productName = data.idGeneralProduct > 0 ? data.mainACCSubHeadList?.find(item => item.id === data.idGeneralProduct)?.name ? data.mainACCSubHeadList?.find(item => item.id === data.idGeneralProduct)?.name : "" : "";
            //data.productName = data.mainEmployeeList?.find(item => item.id === id)?.idGeneralProduct ? this.state.aCCSubHeadList?.find(item => item.id === event.data.idGeneralProduct)?.name : "";
            //data.idGeneralProduct = data.productName ? event.data.idGeneralProduct : 0;
        }
        if (drpIdentity === 'PaymentMode') {
            data.idPaymentMode = id;
            data.paymentMode = name;
        }
        if (drpIdentity === 'depositIn') {
            data.idBank = id;
            data.bankName = name;
        }
        // if (drpIdentity === 'chequeNo') {
        //     data.idChequeBookDetails = id;
        //     data.chequeNo = name;
        // }
        //if()
        this.setState({ receiptDetails: data }, () => {
            // if (drpIdentity === 'selectBank') {
            //     this.usp_Master_ChequeBookSeriesSelectbyBank_ForPaymentMake(id, this.state.receiptDetails.updateStatus);
            // }
        });
    };

    saveItem = () => {
        // debugger
        if (this.isSubmitting) { return; }
        const isValidAllFields = this.isValidAllFields();
        if (isValidAllFields) {
            let details = this.state.receiptDetails;
            if (details !== "") {
                let requestData = {
                    idCashOrAdvance: details.idCashOrAdvance,
                    receiptNo: details.receiptNo,
                    date: details.date,
                    idEmployee: details.idEmployee,
                    paymentMode: details.idPaymentMode,
                    amount: details.amount,
                    idBank: details.idBank,
                    referenceNo: details.refNo,
                    loanNo: details.loanNo,
                    remarks: details.remarks,
                    e_Date: details.idCashOrAdvance > 0 ? details.e_Date ? details.e_Date : new Date().toISOString() : new Date().toISOString(),
                    e_IdUser: this.state.idUser,
                    isUpdated: details.idCashOrAdvance > 0 ? true : false,
                    updatedDate: details.idCashOrAdvance > 0 ? new Date().toISOString() : null,
                    u_IdUser: details.idCashOrAdvance > 0 ? this.state.idUser : null,
                    isDeleted: false,
                    deletedDate: null,
                    d_IdUser: null,
                    idCompany: this.state.idCompany,
                    idAccountHead: details.idGeneralProduct,
                    idFinancialYear: details.idFinancialYear,
                    updateStatus: details.updateStatus,
                };
                this.isSubmitting = true;
                this.setState({ isSaving: true });
                this.accountTransactionServices.submitAddCashOrAdvanceAddUpdate(requestData)
                    .then((response) => {
                        if (response.statusCode == 200 && response.responseItem !== null) {
                            let dynamicData = response.responseItem.responseContent;
                            if (dynamicData !== null) {
                                if (this.state.receiptDetails.updateStatus === 1) {
                                    this.SwalServices.Success("Updated successfully.");
                                } else {
                                    this.SwalServices.Success("Saved successfully.");
                                }

                                // Call resetFields here after submission
                                if (this.state.urlId) {
                                    this.setState({ route: '/ledger-report' });
                                } else {
                                    this.setState(
                                        { isModalOpen: false },
                                        () => {
                                            this.resetDetailsFields(); // Reset fields
                                            this.procSelectAllRecordsSP(); // Fetch latest records
                                        }
                                    );
                                }
                            } else {
                                this.procSelectAllRecordsSP();
                            }
                        }
                    }).finally(() => {
                        this.isSubmitting = false;
                        this.setState({ isSaving: false });
                    });
            } else {
                console.log("Enter valid data")
            }
            //} else {
            //    console.log(this.state.receiptDetails)
            //    console.log(this.state.validState.error)
            //}
            // this.setState({ isModalOpen: !this.state.isModalOpen });

        }
    }

    resetDetailsFields = () => {
        let validState = this.state.validState;
        validState.isValid = true;
        validState.error = {};
        let receiptDetail = this.state.receiptDetails; //{
        receiptDetail.idCashOrAdvance = 0;
        // receiptDetail.receiptNo = "";
        receiptDetail.date = "";
        receiptDetail.refNo = "";
        receiptDetail.amount = "";
        receiptDetail.loanNo = "";
        receiptDetail.remarks = "";
        receiptDetail.idEmployee = 0;
        receiptDetail.employeeName = "";
        receiptDetail.idGeneralProduct = 0;
        receiptDetail.productName = "";
        receiptDetail.idBank = 0;
        receiptDetail.bankName = "";
        receiptDetail.idPaymentMode = 0;
        receiptDetail.paymentMode = "";
        receiptDetail.idFinancialYear = 0;
        receiptDetail.e_Date = "";
        receiptDetail.updateStatus = 0;
        this.setState({ receiptDetails: receiptDetail, validState: validState });
    }

    closePopup = () => {
        if (this.state.urlId) {
            this.setState({ route: '/ledger-report' });
        } else {
            this.setState({ isModalOpen: false, });
        }
    };

    isValidAllFields = () => {
        const newValidState = isValidForm(
            this.state.receiptDetails,
            this.state.validationRules,
            this.state.validState,
        );
        this.setState({ validState: newValidState });
        return newValidState.isValid;
    }

    render() {
        if (this.state.route != null) {
            return <Navigate to={this.state.route} />;
        }
        return (
            <div className='add-cash-advance'>
                <div className="data-display">
                    <div className="data-display-inner relative">
                        <ButtonGrp buttons={['add', 'print', 'delete']}
                            onClickHandlers={{
                                add: () => this.openPopUpForAddingItem(),
                                // update: this.handleSave,
                                print: this.handlePrint,
                                delete: this.handleDelete,
                            }} />
                        <AddCashAdvancePopUp
                            isModalOpen={this.state.isModalOpen}
                            setOpenModel={this.setOpenModel.bind(this)}
                            handleChange={this.handleChange.bind(this)}
                            handleSelectChange={this.handleSelectChange.bind(this)}
                            setFilterParameters={this.setFilterParameters.bind(this)}
                            receiptDetails={this.state.receiptDetails}
                            saveItem={this.saveItem.bind(this)}
                            isSaving={this.state.isSaving}
                            close={this.closePopup.bind(this)}
                            validState={this.state.validState}
                        />
                        <div className="table cursor-default w-full bg-white shadow-normalShadow rounded-[10px] pb-[44px] pt-[10px] px-[10px]">
                            <div className="table-1 w-full px-[1px] rounded-[5px]" style={{ height: "calc(100vh - 156px)" }}>
                                <div className="table-inner">
                                    <h1 className="text-blue text-[16px] font-semibold py-[5px] px-[9px] pt-[0]">Add cash/advance</h1>
                                </div>
                                <AgGridReact
                                    rowData={this.state.rowData}
                                    rowHeight={this.state.rowHeight}
                                    columnDefs={this.state.colDefs}
                                    pagination={true}
                                    paginationPageSize={this.state.paginationPageSize}
                                    onCellClicked={this.handleCellClick}
                                    onRowDoubleClicked={this.onRowDoubleClicked}
                                    onGridReady={this.onGridReady} // Capture API reference
                                    overlayLoadingTemplate={'<span class="ag-overlay-loading-center">Loading data...</span>'}
                                    overlayNoRowsTemplate="<span'>No Rows To Show</span>"
                                />
                            </div>
                        </div>
                        {/* <div className="table w-full mt-[10px] bg-white shadow-normalShadow rounded-[10px] pb-[44px] pt-[10px] px-[10px]">
                            <div className={`table-2 w-full px-[1px] rounded-[5px] ${this.state.isTable2Expanded ? 'h-[448px]' : 'h-[0]'}`}>
                                <div className="table-inner" onClick={() => this.toggleExpandCollapseTable(2)}>
                                    <h1 className="text-blue text-[16px] font-semibold py-[5px] px-[9px] pt-[0]">Details</h1>
                                </div>
                                <AgGridReact
                                    rowData={table2Data}
                                    columnDefs={table2ColDefs}
                                    rowHeight={this.state.rowHeight}
                                    pagination={true}
                                    paginationPageSize={this.state.paginationPageSize}
                                    onGridReady={this.state.onGridReady}
                                />
                            </div>
                        </div> */}
                    </div>
                </div>
            </div>
        )
    }
}
export default AddCashAdvance;